module.exports = __webpack_public_path__ + "img/sortmove-for-sale.ffcf586b.png";